'use client';

import type { ComponentProps } from 'react';

import StreamingHomePage from '../../StreamingHomePage';
import { NEW_2026_PC_COMPONENT_MAP } from './component-map';
import styles from './HomePage.module.css';

type New2026PcProps = Pick<ComponentProps<typeof StreamingHomePage>, 'homeListData' | 'deviceType'>;

export default function NEW_2026_PC_HomePage(props: New2026PcProps) {
  return (
    <div
      className={`${styles.layout} [&>.homepage]:flex [&>.homepage]:flex-col [&>.homepage]:gap-[24px] [&>.homepage]:bg-primary-white [&>.homepage>.index-box:not(:empty)~.index-box:has(>[data-component-id=oneRowFourNav])]:-mt-[24px] min-[1280px]:[&>.homepage]:gap-[48px] min-[1280px]:[&>.homepage>.index-box:not(:empty)~.index-box:has(>[data-component-id=oneRowFourNav])]:-mt-[48px]`}
    >
      <StreamingHomePage {...props} componentMap={NEW_2026_PC_COMPONENT_MAP} />
    </div>
  );
}
